// components/protectedRoute.jsx
import { useContext } from "react";
import { AuthContext } from "../common/constants";
import { Navigate } from "react-router-dom";
import Can from "./can"; // ton composant de check

const ProtectedRoute = ({ perm, anyOf, children }) => {
  const { initialized, isAuthenticated, currentUser } = useContext(AuthContext);

  if (!initialized) return null; // ou spinner
  if (!isAuthenticated) return <Navigate to="/" replace />;

  // pas de permission => accès connecté simple
  if (!perm && !anyOf) return children;

  // vérif perm via Can (tu peux aussi coder le check inline)
  return (
    <Can perm={perm} anyOf={anyOf}>
      {children}
    </Can>
  );
};

export default ProtectedRoute;
